import { render, staticRenderFns } from "./modalDelete.vue?vue&type=template&id=754601ca&scoped=true&"
import script from "./modalDelete.vue?vue&type=script&lang=js&"
export * from "./modalDelete.vue?vue&type=script&lang=js&"
import style0 from "./modalDelete.vue?vue&type=style&index=0&id=754601ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754601ca",
  null
  
)

export default component.exports